import React, { useEffect, useState } from "react";
import { APP_URL, IG_AUTH_REDIRECT_ROUTE, IG_HELPDESK_URL, INIT_IG_AUTH_ROUTE, NEW_IG_AUTH_METHOD } from "../../constants/constants";
import MobileView from "../../layouts/MobileView/MobileView";
import { useNavigate } from "react-router-dom";
import { linkInstagramAccount, storeAccessToken } from "../../services/api/influencer";
import { AppDispatch, getIntendedPath, RootState, store } from "../../redux-stores/store";
import { useDispatch } from "react-redux";
import { fetchInfluencer } from "../../redux-stores/slices/influencerSlice";
import { login } from "../../redux-stores/slices/authSlice";
import { encryptData } from "../../utils/cryptography";
import { debug } from "../../services/api/auth";
import AuthLayout from "../../layouts/AuthLayout";
import ConnectIGComponent from "../../components/igConnect/ConnectIGComponent";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { ConnectIGStatus } from "./ConnectIGRedir";

const REDIRECT_URI = APP_URL + IG_AUTH_REDIRECT_ROUTE;

const ConnectIGRedirCap: React.FC = () => {
    const [connected, setConnected] = useState<boolean>(false);
    const [connecting, setConnecting] = useState<boolean>(false);
    const { isAuthenticated } = useSelector((state: RootState) => state.auth);

    const [error, setError] = useState<any>(null);
    const [status, setStatus] = useState<ConnectIGStatus>(ConnectIGStatus.DEFAULT);

    const [accessCode, setAccessCode] = useState<string|null>(null);

    const dispatch: AppDispatch = useDispatch();

    const navigate = useNavigate();

    useEffect(() => {


        const handleIGRedirection = async (code: string) => {
            setStatus(ConnectIGStatus.RETURN);
            returnToApp(code);
        }

        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        if (code) {
            setAccessCode(code);
            handleIGRedirection(code);
        } else {
            setError("Authorization code not found");
            setStatus(ConnectIGStatus.ERROR);
        }

    }, [navigate, dispatch, isAuthenticated]);

    const returnToApp = (code = accessCode) => {
        const appURL = `influns://c/ig/ig/r?code=${code}`
        window.location.href = appURL;
    }

    useEffect(() => {
        // debug()
        if(!isAuthenticated) return;
        debug({status, error, path: window.location.pathname, origin: window.location.origin}).catch((err) => console.log(err));
    }, [error, status, isAuthenticated]);

    const viewHelpClickHandler = () => {
        debug({status: 'View Help', error, path: window.location.pathname, origin: window.location.origin});
    }
    

    return (
        <MobileView>
            <AuthLayout>
                <ConnectIGComponent 
                    error={error}
                    status={status}
                    connect={() => returnToApp(accessCode)}
                />
            </AuthLayout>
        </MobileView>
    );
};

export default ConnectIGRedirCap;